import { render, staticRenderFns } from "./BrochuresIndex.vue?vue&type=template&id=0ef0ccab"
import script from "./BrochuresIndex.vue?vue&type=script&lang=js"
export * from "./BrochuresIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports